/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Connection_Error_Outage_DescInputs */



/**
* | output |
* | --- |
* | "Our status page is reporting a disruption, so this isn't something on your side. You're still signed in — we'll keep trying, and the app comes back on its ow..." |
*
* @param {Auth_Connection_Error_Outage_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_connection_error_outage_desc = /** @type {((inputs?: Auth_Connection_Error_Outage_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Connection_Error_Outage_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unsere Statusseite meldet eine Störung — es liegt also nicht an dir. Du bist weiterhin angemeldet. Wir versuchen es weiter, und sobald die Plattform wieder läuft, geht es von selbst weiter.")
	return /** @type {LocalizedString} */ ("Our status page is reporting a disruption, so this isn't something on your side. You're still signed in — we'll keep trying, and the app comes back on its own once the platform recovers.")
});